import React from 'react'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'

import { useTheme } from 'styled-components/native'

import { CareProgressData } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { Link } from '../../atoms/link/Link'
import { tID } from '../../utils/utils'

type CareOnboardingStatusProps = {
  status: NonNullable<CareProgressData['careOnboardingStatus']>
  clientFirstName?: string
}

const messages = defineMessages({
  bothIncomplete: {
    defaultMessage: '{clientFirstName} has not completed their consent and intake form',
    description: 'Care consent and intake are both incomplete for this client',
  },
  consentOnly: {
    defaultMessage:
      '{clientFirstName} has completed their <consent>consent form</consent>, but has not completed their intake form',
    description: 'Care consent is complete but intake is incomplete for this client',
  },
  bothComplete: {
    defaultMessage: '{clientFirstName} has completed their <consent>consent</consent> and <intake>intake form</intake>',
    description: 'Care consent and intake are both complete for this client',
  },
  clientFallback: {
    defaultMessage: 'The client',
    description: 'Subject used in care onboarding status when the client has no first name',
  },
})

export const CareOnboardingStatus: React.FC<CareOnboardingStatusProps> = ({ status, clientFirstName }) => {
  const { colors } = useTheme()
  const { formatMessage } = useIntl()

  return (
    <BodyText
      testID={tID('care-onboarding-status')}
      color={status.state === 'bothIncomplete' ? colors.textWarning : colors.textSecondary}
    >
      <FormattedMessage
        {...messages[status.state]}
        values={{
          clientFirstName: clientFirstName || formatMessage(messages.clientFallback),
          consent: (chunks: React.ReactNode) => (
            <Link text={chunks} onPress={status.onViewConsent} testID={tID('view-consent-form-link')} underline />
          ),
          intake: (chunks: React.ReactNode) => (
            <Link text={chunks} onPress={status.onViewIntake} testID={tID('view-intake-form-link')} underline />
          ),
        }}
      />
    </BodyText>
  )
}
